import { render, staticRenderFns } from "./MemberInfoAssetsList.vue?vue&type=template&id=0a8957c3&scoped=true&"
import script from "./MemberInfoAssetsList.vue?vue&type=script&lang=js&"
export * from "./MemberInfoAssetsList.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfoAssetsList.vue?vue&type=style&index=0&id=0a8957c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8957c3",
  null
  
)

export default component.exports